import { render, staticRenderFns } from "./supplier-base.vue?vue&type=template&id=8aa9742c&"
import script from "./supplier-base.vue?vue&type=script&lang=ts&"
export * from "./supplier-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports